const TRANSITION_TIME = 0.5; // in sec

function swapPanels($panelTop, $panelBottom, cb) {
  const panelTopMargin = parseFloat($panelTop.css('margin-top'));
  const panelBottomMargin = parseFloat($panelBottom.css('margin-top'));

  const moveUp = -1 * $panelTop.height() - panelTopMargin;
  const moveDown = $panelBottom.height() + panelBottomMargin;

  $panelTop.css({
    transition: 'top ' + TRANSITION_TIME + 's',
    '-webkit-transition': 'top ' + TRANSITION_TIME + 's',
    top: moveDown + 'px'
  });

  $panelBottom.css({
    transition: 'top ' + TRANSITION_TIME + 's',
    '-webkit-transition': 'top ' + TRANSITION_TIME + 's',
    top: moveUp + 'px'
  });

  setTimeout(function () {
    // switch places in the markup
    $panelBottom.insertBefore($panelTop);

    // reset 'top' offsets
    $([$panelTop, $panelBottom]).each(function () {
      this.css({
        transition: 'top 0s',
        '-webkit-transition': 'top 0s',
        top: '0px'
      });
    });

    if (cb) {
      cb();
    }
  }, TRANSITION_TIME * 1000);
}

function initFormset(formset_name, post_init_cb, get_initial_cb) {
  function update_ordering_numbers() {
    // update order field
    $('[data-formset-container=' + formset_name + '] [name^=' + formset_name + '-][name$=-order]').each((i, o) => {
      // TODO: eliminate ugly hardcoded values
      const name1 = $(o).closest('[data-inline]').data('inline') + '-screening_question';
      const name2 = $(o).closest('[data-inline]').data('inline') + '-question';
      if ($('[name=' + name1 + ']').val() || $('[name=' + name2 + ']').val()) {
        $(o).val(i + 1);
      }
    });
  }

  function update_up_down_buttons() {
    $(
      '[data-formset-container=' +
        formset_name +
        '] .move-up, ' +
        '[data-formset-container=' +
        formset_name +
        '] .move-down'
    ).attr('disabled', false);

    $('[data-formset-container=' + formset_name + '] .move-up:visible')
      .first()
      .attr('disabled', true);
    $('[data-formset-container=' + formset_name + '] .move-down:visible')
      .last()
      .attr('disabled', true);
  }

  // Inner helper function for attaching click-listerner to the "Delete" buttons
  function init_delete_button(el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementsByName(e.target.attributes['data-name'].value)[0].checked = 'checked';

      var toRemove = e.target.attributes['data-to-remove'].value;
      var container = document.querySelector('[data-inline=' + toRemove + ']');
      container.style.display = 'none';

      // enable/disable up down buttons
      update_up_down_buttons();
      return false;
    });
  }

  function init_up_button(el) {
    if (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        const $panel = $(el).closest('.orderable-panel');
        const $prevPanel = $panel.prev();

        swapPanels($prevPanel, $panel, () => {
          // update order fields after swapped
          // update_ordering_numbers()

          // enable/disable up down buttons
          update_up_down_buttons();
        });

        return false;
      });
    }
  }

  function init_down_button(el) {
    if (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        const $panel = $(el).closest('.orderable-panel').last();
        const $nextPanel = $panel.next();

        swapPanels($panel, $nextPanel, () => {
          // update order fields after swapped
          // update_ordering_numbers()
          // enable/disable up down buttons
          update_up_down_buttons();
        });

        return false;
      });
    }
  }

  var add_button = document.querySelector('[data-formset-add=' + formset_name + ']');
  var empty_form_template = document.querySelector('[data-formset-empty=' + formset_name + ']');
  var target_container = document.querySelector('[data-formset-container=' + formset_name + ']');

  // Add click-handler to the "add-button":
  if (add_button) {
    add_button.addEventListener('click', function (e) {
      e.preventDefault();

      // get 'total_forms' current value
      var total_forms = parseInt(document.querySelector('[name=' + formset_name + '-TOTAL_FORMS]').value);

      // copy empty_form code and replace index
      var empty_form_html = empty_form_template.innerHTML;
      var new_form_html = empty_form_html.replace(/"(.*?)__prefix__(.*?)"/g, '"$1' + total_forms + '$2"');

      const $new_form = $(new_form_html);
      $(target_container).append($new_form);

      // set up initial values for the new form
      if (get_initial_cb) {
        var data = get_initial_cb();
        for (var key in data) {
          // Loop though keys and values
          if (data.hasOwnProperty(key)) {
            var field_name = formset_name + '-' + total_forms + '-' + key;
            var field_value = data[key];
            $new_form.find('[name=' + field_name + ']').val(field_value);
          }
        }
      }

      // update 'total_forms' value
      document.querySelector('[name=' + formset_name + '-TOTAL_FORMS]').value = total_forms + 1;

      if (post_init_cb) {
        post_init_cb($new_form);
      }

      // init delete button
      init_delete_button($new_form.find('.inline-delete[data-name^="' + formset_name + '"]')[0]);

      // init up and down buttons
      init_up_button($new_form.find('.move-up')[0]);
      init_down_button($new_form.find('.move-down')[0]);

      // set the very first and last up and down button to disabled
      update_up_down_buttons();

      // update order fields
      // update_ordering_numbers()

      // initialize inner formsets within the newly added row if any
      var inner_formset = $new_form.find('[data-formset-container]');
      if (inner_formset.length) {
        var inner_formset_name = inner_formset.data('formset-container');
        initFormset(inner_formset_name);
      }

      return false;
    });
  }

  // Add click-handler to the initial delete buttons for this inline-formset:
  document.querySelectorAll('.inline-delete[data-name^="' + formset_name + '"]').forEach(init_delete_button);

  // Add click-handler to the move-up buttons for this inline-formset:
  document.querySelectorAll('[data-formset-container=' + formset_name + '] .move-up').forEach(init_up_button);

  // Add click-handler to the move-down buttons for this inline-formset:
  document.querySelectorAll('[data-formset-container=' + formset_name + '] .move-down').forEach(init_down_button);

  // set the very first and last up and down button to disabled
  update_up_down_buttons();

  // update order fields
  //update_ordering_numbers()

  // Initilize inner formsets if any
  var innerFormsets = target_container ? target_container.querySelectorAll(['[data-formset-container]']) : [];
  innerFormsets.forEach(function (el) {
    var inner_formset_name = el.attributes['data-formset-container'].value;
    initFormset(inner_formset_name);
  });

  const $form = $('[data-formset-container=' + formset_name + ']').closest('form');
  $form.submit(function () {
    // update order fields
    update_ordering_numbers();
    return true;
  });
}

export { initFormset };
